import React, { useLayoutEffect } from 'react';
import { getTimestamp, now } from 'owa-datetime';
import { ShowUpNextEventWrapper } from '..';
import {
    useUpNextStateDispatch,
    useUpNextStateStaticObject,
} from 'mini-upnext/lib/components/UpNextStateContext';

/**
 * Shows UpNext card in List view
 */
const UpNextCard = (props: { style?: React.CSSProperties }): JSX.Element => {
    const upNextStaticObject = useUpNextStateStaticObject();
    const { payload } = upNextStaticObject.current;
    const { updateUpNextStaticObject } = useUpNextStateDispatch();

    useLayoutEffect(() => {
        payload.mountTimestamp = getTimestamp(now());
        return () => {
            updateUpNextStaticObject({ listViewScrolled: true });
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useLayoutEffect has missing dependencies: 'payload' and 'updateUpNextStaticObject'. Either include them or remove the dependency array. */
    }, []);

    return <ShowUpNextEventWrapper style={props.style} />;
};

export default UpNextCard;
